// import { ProductsService } from '../api';

interface FilesProductProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: File[]; total: number }>;
}

export const filesProductPrivider: FilesProductProviderResource = {
  getList: async (resource, params) => {
    console.log(params);
    const { files } = params.filter;
    if (!files) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: files,
      total: files.length,
    };
  },
};
